import { del, get, post } from './httpClient';

/**
 * GET /getcadprojectmembers?id= — Owner / staff (`can_publish`). Ajeno → 404.
 * `data[]` trae `email` y `user_id` (este puede ser null si todavía no hay cuenta).
 *
 * @param {string} projectId
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function getCadProjectMembers(projectId, { signal } = {}) {
  const id = String(projectId || '').trim();
  if (!id) {
    return { data: [], _httpOk: false, _httpStatus: null };
  }
  return get('/getcadprojectmembers', { params: { id }, signal });
}

/**
 * POST /upsertcadprojectmember `{ id, email }`. 201 alta / 200 update.
 * 400 si te invitás a vos.
 *
 * @param {{ id: string, email: string }} body
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function upsertCadProjectMember(body, { signal } = {}) {
  return post('/upsertcadprojectmember', {
    body: {
      id: body?.id,
      email: String(body?.email || '').trim().toLowerCase(),
    },
    signal,
  });
}

/**
 * DELETE /deletecadprojectmember?id=&email= (o `user_id` si no hay email).
 *
 * @param {{ id: string, email?: string, user_id?: string }} body
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function deleteCadProjectMember(body, { signal } = {}) {
  const email = String(body?.email || '').trim().toLowerCase();
  const userId = String(body?.user_id || '').trim();
  return del('/deletecadprojectmember', {
    params: {
      id: body?.id,
      ...(email ? { email } : {}),
      ...(!email && userId ? { user_id: userId } : {}),
    },
    signal,
  });
}
